import { format, parse } from 'date-fns';
 
export const formatDate = (dateString: string | null) => {
  if (!dateString) return 'Não definido';

  let parsedDate: Date; 

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    // Cria a data manualmente como local
    const [year, month, day] = dateString.split('-').map(Number);
    parsedDate = new Date(year, month - 1, day);
  } else {
    parsedDate = parse(dateString, 'dd/MM/yyyy', new Date());
  }

  if (isNaN(parsedDate.getTime())) return 'Data inválida';

  return format(parsedDate, 'dd/MM/yyyy');
};

export const toDbFormat = (dateString: string | null) => {
  if (!dateString) return null;

  try {
    // Converte de dd/MM/yyyy para objeto Date
    const parsedDate = parse(dateString, 'dd/MM/yyyy', new Date());
    return format(parsedDate, 'yyyy-MM-dd');
  } catch {
    return dateString;
  }
};